import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { HashRouter as Router } from "react-router-dom";
import ProductsProvider from "./context/ProductsContext";

ReactDOM.render(
  <React.StrictMode>
    <ProductsProvider>
      <Router forceRefresh={true}>
        <App />
      </Router>
    </ProductsProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
